export const ClientPoolSelectors = {
    HaveUpdates: (state) => state.ClientPool.haveUpdates,
};
